<!--
* @description  参数1
* @fileName  contactIndex
* @author userName
* @date 2024-01-25 09:27:53
!-->
<template>
  <div id="contactIndex" class="contactIndex">
    <div v-if="!isDetails" class="contact-form">
      <div class="contact-title">
        <div class="contact-title-one">{{ activeName }}</div>
        <!--        <div v-if="addrType==0" class="contact-title-two">The exporter of record for your shipment. Usually the
          factory, sourcing agent, etc.</div>
        <div v-if="addrType==1" class="contact-title-two">The importer of record responsible for paying duties and freight charges. Usually you or your client.</div> -->
      </div>
      <div class="contact-main">
        <ByForm ref="AddressForm" @save="goToDetails" @cencel="goToDetails" />
      </div>
    </div>
    <div v-if="isDetails">
      <ContactDetails
        ref="ContactDetails"
        :active-name="activeName"
        @isSelect="isSelectContact"
        @isEdit="isEdit"
      />
    </div>
    <SelectContact ref="selec" :is-select="isSelectShow" @next="next" />
  </div>
</template>

<script>
import {
  GetCustomerAddress
} from '../../../../../../../api/user.js'
import {
  GetOrderAddress
} from '../../../../../../../api/order.js'
import ByForm from './byForm.vue'
import ContactDetails from './contactDetails.vue'
import SelectContact from './selectContact.vue'
export default {
  name: 'ContactIndex',
  components: {
    // 组件的引用
    ByForm,
    ContactDetails,
    SelectContact
  },
  props: {
    // 父辈向子辈传参
    activeName: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      isDetails: false,
      isSelectShow: false,
      data: {},
      addrType: undefined,
      addressList: [],
	    contactIndex: 0
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    next(stepName) {
      console.log(stepName)
      console.log(this.contactIndex + 1)
      this.$emit('next', stepName, this.contactIndex + 1)
    },
    init(data, index) {
      this.contactIndex = index
      this.isSelectShow = false
      this.isDetails = false
      this.data = data
      switch (this.activeName) {
        case '取件地址':
          this.addrType = 2
          break
        case '发件人地址':
          this.addrType = 0
          break
        case '派送地址':
          this.addrType = 7
          break
        case '收件人地址':
          this.addrType = 1
          break
      }
      GetOrderAddress({
        addrType: this.addrType,
        orderNo: data.orderNo
      }).then(res => {
        if (res.code === 200) {
          if (res.data && res.data.name) {
            this.goToDetails()
          } else {
            var queryData = {
              addrType: this.addrType
            }
            if (this.addrType === 2) {
              queryData.city = this.data.startCityNameEn
            }
            GetCustomerAddress(queryData).then(res => {
              if (res.code === 200) {
                if (res.data && res.data.length > 0) {
                  this.addressList = res.data
                  this.isSelectShow = true
                  this.$nextTick(() => {
                  					  this.$refs.selec.init(data, this.addrType)
                    this.$refs.AddressForm.init(data, this.addrType)
                  })
                } else {
                  this.isSelectShow = false
                  this.isDetails = false
                  this.$nextTick(() => {
                    this.$refs.AddressForm.init(data, this.addrType)
                  })
                }
              }
            })
          }
        }
      })
    },
    // 方法
    goToDetails() {
      this.isDetails = true
      this.$nextTick(() => {
        this.$refs.ContactDetails.init(this.data, this.addrType)
      })
    },
    isSelectContact() {
      this.$refs.selec.init(this.data, this.addrType)
      this.isSelectShow = true
    },
    isEdit(data) {
      this.isDetails = false
      this.$nextTick(() => {
        this.$refs.AddressForm.init(this.data, this.addrType, data, false, true)
      })
    },
    selectClose() {
      this.isSelectShow = false
      GetOrderAddress({
        addrType: this.addrType,
        orderNo: this.data.orderNo
      }).then(res => {
        if (res.data) {
          this.goToDetails()
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.font400 {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	.contactIndex {
		.contact-form {
			width: 964px;
			height: auto;
			background: #FFFFFF;
			border-radius: 8px;
			padding: 0 16px;

			.contact-title {
				text-align: left;
				border-bottom: 1px solid #DDDDDD;
				padding: 15px 0 13px 0;
				margin-bottom: 20px;

				.contact-title-one {
					font-size: 18px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 600;
					color: #333333;
				}

				.contact-title-two {
					@extend .font400;
					margin-top: 11px;
				}
			}
		}
	}
</style>
